<template>
  <Dialog
    v-model:visible="isVisible"
    class="col-12 lg:col-6"
    :modal="true"
    :closable="true"
    :dismissable-mask="true"
  >
    <template #header>
      <h3>{{ $t('dialog.barcodeform.title') }}</h3>
    </template>
    <form @submit.prevent="create">
      <BarcodeRangeInput
        v-model:start="barcode.start"
        v-model:number="barcode.number"
        v-model:valid="rangeValid"
      />

      <div class="col-12 text-right">
        <Button
          :label="$t('action.crud.create')"
          type="submit"
          icon="pi pi-plus"
          class="p-button-rounded p-button-outlined mt-2"
          :disabled="!rangeValid || isSaving"
        />
      </div>
    </form>
    <Message
      v-if="errors.length > 0"
      severity="error"
      :closable="false"
    >
      <ul class="list-none m-0 p-0">
        <li
          v-for="error of errors"
          :key="error"
        >
          {{ $t(error) }}
        </li>
      </ul>
    </Message>
  </Dialog>
</template>

<script>
import Button from "primevue/button";
import Dialog from "primevue/dialog";
import Message from "primevue/message";
import BarcodeRangeCreateForLineIdRequest from "@/models/dto/requests/BarcodeRangeCreateForLineIdRequest";
import BarcodeRangeInput from "@/components/barcodes/BarcodeRangeInput.vue";

export default {
  name: 'BarcodeAddToLineIdDialog',
  components: {
    BarcodeRangeInput,
    Dialog,
    Button,
    Message
  },
  props: {
    visible: {
      type: Boolean,
    },
    lineId: {
      type: Object,
      required: true,
    },
  },

  emits: ['update:visible', 'create'],

  data() {
    return {
      isSaving: false,
      errors: [],
      rangeValid: true,
      barcode: {
        start: 0,
        number: 1,
        stakeholderId: this.lineId.stakeholderId
      },
    }
  },
  computed: {
    isVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit('update:visible', value);
        this.resetForm();
      }
    }
  },

  methods: {
    async create() {
      try {
        this.isSaving = true;
        const request = new BarcodeRangeCreateForLineIdRequest({
          start: this.barcode.start,
          number: this.barcode.number,
          lineId: this.lineId.id
        })
        const result = await this.$barcodeService.createForLineId(request)

        if (result && this.lineId) {
          await this.toggleControl(result.id, true);
        }

        this.$emit('create', result);
        this.$emitter.emit("toast", {
          severity: "success",
          message: "dialog.barcodeform.toast.success",
        });
        this.isVisible = false;
      } catch (e) {
        this.errors = e.response.data;
      } finally {
        this.isSaving = false;
      }
    },

    resetForm() {
      this.barcode.start = 0;
      this.barcode.number = 1;
      this.errors = [];
      this.exists = false;
    },
    async toggleControl(barcodeId, value) {
      try {
        const association = {[this.lineId.id]: value};
        await this.$controlService.toggleControlsByBarcodeRangeAndLineIds(barcodeId, association);
      } catch (e) {
        const errors = e.response.data.map(error => this.$t(error));
        this.$emitter.emit('toast', {severity: 'error', message: errors.join(', ')});
      }
    },

  }
}
</script>
